import {
  createBrowserRouter,
  matchRoutes,
  useLocation,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import {
  NotFound,
  LoginPage,
  AuthPage,
  ProfilePage,
  Home,
  RevenuePage,
  SystemPage,
  LimitCheckErrCodePackage,
  RevenueReport,
  Statistical,
  CreateStatistical,
  EditStatistical,
  TransactionRetry,
  TransactionReports,
  AuditTrailExport,
  DataSponsorStatistics,
  PartnerList,
  CreatePartner,
  EditPartner,
  ProviderList,
  CreateNetworkProvider,
  EditNetworkProvider,
  CreateVDSProvider,
  EditVDSProvider,
  CreateTDMProvider,
  EditTDMProvider,
  PartnerManagement,
  PackageManagement,
  CreatePartnerSponsor,
  CreatePartnerSponsorPromotion,
  CreatePartnerCode,
  EditPartnerSponsor,
  EditPartnerCode,
  Packages,
  CreatePackagesSponsor,
  CreatePackagesCode,
  EditPackagesSponsor,
  EditPackagesCode,
  TransactionOverview,
  Dashbooard,
} from "../pages";
import {
  AUTH_LOGIN,
  HOME,
  PROFILE,
  TRANSACTIONS,
  PACKAGES,
  REVENUES,
  OVERVIEW,
  STATISTICAL,
  CREATE_STATISTICAL,
  EDIT_STATISTICAL,
  CREATE_PACKAGES_SPONSOR,
  CREATE_PACKAGES_CODE,
  SYSTEM,
  SYSTEM_CONFIGURATION,
  LIMIT_CHECK_ERR_CODE_PACKAGE,
  EDIT_PACKAGES_SPONSOR,
  EDIT_PACKAGES_CODE,
  REPORT,
  DASHBOARD,
  REPORTS_ANALYTICS,
  TRANSACTION_REPORTS,
  AUDIT_TRAIL_EXPORT,
  DATA_SPONSOR_STATISTICS,
  PARTNERS_LIST,
  CREATE_PARTNER,
  EDIT_PARTNER,
  PROVIDER_LIST,
  CREATE_NETWORK_PROVIDER,
  EDIT_NETWORK_PROVIDER,
  CREATE_VDS_PROVIDER,
  EDIT_VDS_PROVIDER,
  CREATE_TDM_PROVIDER,
  EDIT_TDM_PROVIDER,
  PARTNERS,
  PARTNER_MANAGEMENT,
  PACKAGE_MANAGEMENT,
  CREATE_PARTNER_SPONSOR,
  CREATE_PARTNER_SPONSOR_PROMOTION,
  CREATE_PARTNER_CODE,
  EDIT_PARTNER_SPONSOR,
  EDIT_PARTNER_SPONSOR_PROMOTION,
  EDIT_PARTNER_CODE,
  TRANSACTION_OVERVIEW,
  TRANSACTION_RETRY, ACCOUNT_MANAGEMENT,
} from "../assets/constants/route_path";
import Layout from "../layout";
import PrivateRoute from "../components/private-route";

export const routes = [
  {
    path: "/auth",
    element: <AuthPage />,
    children: [
      {
        path: AUTH_LOGIN,
        element: <LoginPage />,
      },
    ],
  },

  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: HOME,
        element: (
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        ),
      },
      {
        path: REVENUES + OVERVIEW,
        element: (
          <PrivateRoute>
            <RevenuePage />
          </PrivateRoute>
        ),
      },
      {
        path: REVENUES + REPORT,
        element: (
          <PrivateRoute>
            <RevenueReport />
          </PrivateRoute>
        ),
      },
      {
        path: REVENUES + STATISTICAL,
        element: (
          <PrivateRoute>
            <Statistical />
          </PrivateRoute>
        ),
      },
      {
        path: REVENUES + STATISTICAL + CREATE_STATISTICAL,
        element: (
          <PrivateRoute>
            <CreateStatistical />
          </PrivateRoute>
        ),
      },
      {
        path: REVENUES + STATISTICAL + EDIT_STATISTICAL,
        element: (
          <PrivateRoute>
            <EditStatistical />
          </PrivateRoute>
        ),
      },
      {
        path: SYSTEM + SYSTEM_CONFIGURATION,
        element: (
          <PrivateRoute>
            <SystemPage />
          </PrivateRoute>
        ),
      },
      {
        path: SYSTEM + LIMIT_CHECK_ERR_CODE_PACKAGE,
        element: (
          <PrivateRoute>
            <LimitCheckErrCodePackage />
          </PrivateRoute>
        ),
      },
      {
        path: PROFILE,
        element: <ProfilePage />,
      },
      {
        path: DASHBOARD,
        element: (
          <PrivateRoute>
            <Dashbooard />
          </PrivateRoute>
        ),
      },
      {
        path: TRANSACTIONS + TRANSACTION_OVERVIEW,
        element: (
          <PrivateRoute>
            <TransactionOverview />
          </PrivateRoute>
        ),
      },
      {
        path: TRANSACTIONS + TRANSACTION_RETRY,
        element: (
          <PrivateRoute>
            <TransactionRetry />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGES,
        element: (
          <PrivateRoute>
            <Packages />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGES + CREATE_PACKAGES_SPONSOR,
        element: (
          <PrivateRoute>
            <CreatePackagesSponsor />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGES + CREATE_PACKAGES_CODE,
        element: (
          <PrivateRoute>
            <CreatePackagesCode />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGES + EDIT_PACKAGES_SPONSOR,
        element: (
          <PrivateRoute>
            <EditPackagesSponsor />
          </PrivateRoute>
        ),
      },
      {
        path: PACKAGES + EDIT_PACKAGES_CODE,
        element: (
          <PrivateRoute>
            <EditPackagesCode />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PARTNER_MANAGEMENT,
        element: (
          <PrivateRoute>
            <PartnerManagement />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PACKAGE_MANAGEMENT,
        element: (
          <PrivateRoute>
            <PackageManagement />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PACKAGE_MANAGEMENT + CREATE_PARTNER_SPONSOR,
        element: (
          <PrivateRoute>
            <CreatePartnerSponsor />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PACKAGE_MANAGEMENT + CREATE_PARTNER_SPONSOR_PROMOTION,
        element: (
          <PrivateRoute>
            <CreatePartnerSponsorPromotion />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PACKAGE_MANAGEMENT + CREATE_PARTNER_CODE,
        element: (
          <PrivateRoute>
            <CreatePartnerCode />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PACKAGE_MANAGEMENT + EDIT_PARTNER_SPONSOR,
        element: (
          <PrivateRoute>
            <EditPartnerSponsor />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PACKAGE_MANAGEMENT + EDIT_PARTNER_SPONSOR_PROMOTION,
        element: (
          <PrivateRoute>
            <EditPartnerSponsor />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS + PACKAGE_MANAGEMENT + EDIT_PARTNER_CODE,
        element: (
          <PrivateRoute>
            <EditPartnerCode />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PARTNERS_LIST,
        element: (
          <PrivateRoute>
            <PartnerList />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PARTNERS_LIST + CREATE_PARTNER,
        element: (
          <PrivateRoute>
            <CreatePartner />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PARTNERS_LIST + EDIT_PARTNER,
        element: (
          <PrivateRoute>
            <EditPartner />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PROVIDER_LIST,
        element: (
          <PrivateRoute>
            <ProviderList />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PROVIDER_LIST + CREATE_NETWORK_PROVIDER,
        element: (
          <PrivateRoute>
            <CreateNetworkProvider />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PROVIDER_LIST + EDIT_NETWORK_PROVIDER,
        element: (
          <PrivateRoute>
            <EditNetworkProvider />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PROVIDER_LIST + CREATE_VDS_PROVIDER,
        element: (
          <PrivateRoute>
            <CreateVDSProvider />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PROVIDER_LIST + EDIT_VDS_PROVIDER,
        element: (
          <PrivateRoute>
            <EditVDSProvider />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PROVIDER_LIST + CREATE_TDM_PROVIDER,
        element: (
          <PrivateRoute>
            <CreateTDMProvider />
          </PrivateRoute>
        ),
      },
      {
        path: ACCOUNT_MANAGEMENT + PROVIDER_LIST + EDIT_TDM_PROVIDER,
        element: (
          <PrivateRoute>
            <EditTDMProvider />
          </PrivateRoute>
        ),
      },
      {
        path: REPORTS_ANALYTICS + TRANSACTION_REPORTS,
        element: (
          <PrivateRoute>
            <TransactionReports />
          </PrivateRoute>
        ),
      },
      {
        path: REPORTS_ANALYTICS + AUDIT_TRAIL_EXPORT,
        element: (
          <PrivateRoute>
            <AuditTrailExport />
          </PrivateRoute>
        ),
      },
      {
        path: REPORTS_ANALYTICS + DATA_SPONSOR_STATISTICS,
        element: (
          <PrivateRoute>
            <DataSponsorStatistics />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export const useMatchedRoute = () => {
  const location = useLocation();
  const matchedRoutes = matchRoutes(routes, location);

  if (!matchedRoutes || matchedRoutes.length === 0) {
    return undefined;
  }

  // Sort by accuracy desc
  matchedRoutes.reverse();

  for (let matchedRoute of matchedRoutes) {
    const matchedRoutePath = matchedRoute.route.path;
    // index route will not contain path attr -> get next route (parent route)
    if (matchedRoutePath) {
      return matchedRoutePath;
    }
  }

  return undefined;
};

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
export const router = sentryCreateBrowserRouter(routes);
